var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition",
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attr = _ref.attr;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": ""
          },
          on: {
            "click": _vm.initialize
          }
        }, 'v-btn', attr, false), on), [_c('v-icon', [_vm._v("mdi-plus")])], 1)];
      }
    }]),
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pt-4",
    class: _vm.color
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1), _c('h4', {
    staticClass: "text-truncate"
  }, [_vm._v(_vm._s(_vm.$t("components.thg.ThgBatchSelectDialog.title")))]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.emitSelected
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.thg.ThgBatchSelectDialog.btnText")) + " ")])], 1), _c('v-divider'), _c('v-card-text', [_c('p', {
    staticClass: "mt-4"
  }), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "disabled": _vm.typeLock,
      "items": _vm.types,
      "outlined": "",
      "persistent-hint": ""
    },
    on: {
      "change": _vm.getItems
    },
    model: {
      value: _vm.currentType,
      callback: function callback($$v) {
        _vm.currentType = $$v;
      },
      expression: "currentType"
    }
  })], 1)], 1), _c('v-card', {
    staticClass: "mt-8",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    class: _vm.color
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "append-icon": "mdi-magnify",
      "label": _vm.$t('components.thg.ThgBatchSelectDialog.search'),
      "single-line": "",
      "hide-details": "",
      "outlined": ""
    },
    model: {
      value: _vm.search,
      callback: function callback($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  })], 1), _c('v-spacer'), _c('filter-card-pagination', {
    attrs: {
      "hideDivider": true,
      "filterList": _vm.paginationFilterList,
      "filter": _vm.paginationFilter,
      "isSerachActivated": false
    },
    on: {
      "update:filter": function updateFilter($event) {
        _vm.paginationFilter = $event;
      },
      "confirmFilter": _vm.getItems
    }
  })], 1)], 1), _c('v-divider'), _c('v-data-table', {
    staticClass: "mt-4",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.allThgsToBatch,
      "item-key": "id",
      "show-select": "",
      "disable-pagination": "",
      "hide-default-footer": "",
      "loading": _vm.isLoading || _vm.loading,
      "search": _vm.search
    },
    scopedSlots: _vm._u([{
      key: "item.timestamp.created",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('span', [_vm._v(_vm._s(new Date(item.timestamp.created).toLocaleString("de-DE", _vm.dateOptions)))])];
      }
    }], null, true),
    model: {
      value: _vm.selectedThg,
      callback: function callback($$v) {
        _vm.selectedThg = $$v;
      },
      expression: "selectedThg"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }